export enum EContentSources {
    Website = 4,
    MiniLanding = 5,
    Education = 7,
    WebEducation = 8,
    ChatBot = 9,
    PopUp = 10,
    WebChatBot = 11,
}

export const EContentSourcesWebsite = [
    EContentSources.Website,
    EContentSources.WebEducation,
    EContentSources.WebChatBot,
] as const;

export const EContentSourcesMLP = [
    EContentSources.MiniLanding,
    EContentSources.Education,
    EContentSources.ChatBot,
    EContentSources.PopUp,
] as const;
